import React from "react"
import intl from "react-intl-universal"
import { Text, View } from "@react-pdf/renderer"
import { styles } from "./styles"
import { fnFormatDate } from "../../../../../../../utils/date"

export const HeaderFilters = ({ report }) => {
  const filters = report?.filters

  return (
    <View style={styles.boxFilters} fixed>
      <Text style={styles.title}>{intl.get("ciqReport.pdf.filters.title")}</Text>
      <View style={styles.wrapperFilters}>
        <View>
          <Text style={styles.label}>{intl.get("ciqReport.pdf.filters.equipments")}</Text>
          <View style={{ ...styles.containerFilters, ...styles.listFilter }}>
            <RcmpFilterEquipments report={report} />
          </View>
        </View>
        <View>
          <Text style={styles.label}>{intl.get("ciqReport.pdf.filters.analytes")}</Text>
          <View style={{ ...styles.containerFilters, ...styles.listFilter }}>
            <RcmpFilterAnalytes report={report} />
          </View>
        </View>
        <View>
          <Text style={styles.label}>
            {intl.get("ciqReport.pdf.filters.launch_period")}
          </Text>
          <View style={styles.containerFilters}>
            <Text style={styles.element}>
              {fnFormatDate(filters?.start_date, "DD/MM/YYYY")}{" "}
              {intl.get("ciqReport.pdf.filters.until")}{" "}
              {fnFormatDate(filters?.end_date, "DD/MM/YYYY")}
            </Text>
          </View>
        </View>
        <View>
          <Text style={styles.label}>
            {intl.get("ciqReport.pdf.filters.analyte_status")}
          </Text>
          <View style={styles.containerFilters}>
            <Text style={styles.element}>
              {!filters?.status?.length
                ? intl.get("ciqReport.pdf.filters.all")
                : Number(filters.status)
                ? intl.get("ciqReport.pdf.filters.active")
                : intl.get("ciqReport.pdf.filters.inactive")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  )
}

function RcmpFilterEquipments({ report }) {
  const filtersEquipments = report?.filters?.equipments
  if (filtersEquipments?.length > 0) {
    const cEquipmentsTexts = filtersEquipments?.map((item) => item)?.join("; ")

    return (
      <Text strokeWidth={50} style={styles.element}>
        {cEquipmentsTexts}
      </Text>
    )
  }

  const listEquipments = report?.equipment
  if (listEquipments?.length > 0) {
    const cEquipmentsTexts = listEquipments
      ?.map((item) => item?.equipment_cname)
      ?.join("; ")

    return (
      <Text strokeWidth={50} style={styles.element}>
        {cEquipmentsTexts}
      </Text>
    )
  }

  return (
    <Text strokeWidth={50} style={styles.element}>
      {intl.get("ciqReport.pdf.filters.all")}
    </Text>
  )
}

function RcmpFilterAnalytes({ report }) {
  const listEquipments = report?.equipment

  const listAnalytes = listEquipments?.flatMap((eqp) => eqp.equipment_analytes)
  const uniqueAnalytes = listAnalytes.filter(
    (item, index, self) =>
      self.findIndex(
        (obj) => obj?.eqpanlt_anlt?.anlt_nid === item?.eqpanlt_anlt?.anlt_nid,
      ) === index,
  )

  if (uniqueAnalytes?.length > 0) {
    const cAnalytesTexts = uniqueAnalytes
      ?.map((item) => item?.eqpanlt_anlt?.anlt_cname)
      ?.join("; ")

    return <Text style={styles.element}>{cAnalytesTexts}</Text>
  }

  return (
    <Text strokeWidth={50} style={styles.element}>
      {intl.get("ciqReport.pdf.filters.all")}
    </Text>
  )
}
